"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var RemainingChars_1 = require("components/RemainingChars");
var styles = __importStar(require("./TextArea.module.css"));
var TextArea = (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, rows = _a.rows, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, className = _a.className, maxLength = _a.maxLength;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root + " " + className;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", null,
            React.createElement("textarea", { rows: rows, className: css, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, placeholder: placeholder, disabled: disabled, maxLength: maxLength }),
            maxLength && !window.isPdf && (React.createElement(RemainingChars_1.RemainingChars, { maxLength: maxLength, value: value })),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    TextArea.defaultProps = {
        rows: 5,
        errors: {}
    };
    return TextArea;
}(react_1.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEFyZWEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1RleHRBcmVhL1RleHRBcmVhLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQiw0REFBd0Q7QUFDeEQsNERBQStDO0FBYy9DO0lBQThCLDRCQUFvQjtJQUFsRDs7SUErQ0EsQ0FBQztJQXpDVSx5QkFBTSxHQUFiO1FBQ1UsSUFBQSxlQVVRLEVBVFYsVUFBRSxFQUNGLHdCQUFTLEVBQ1Qsc0JBQVEsRUFDUixjQUFJLEVBQ0osNEJBQVcsRUFDWCxzQkFBUSxFQUNSLGtCQUFNLEVBQ04sd0JBQVMsRUFDVCx3QkFDVSxDQUFBO1FBQ2QsSUFBTSxLQUFLLEdBQUcsU0FBUyxDQUFDLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUNqQyxJQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUE7UUFFeEIsSUFBSSxHQUFHLEdBQU0sTUFBTSxDQUFDLElBQUksU0FBSSxTQUFXLENBQUE7UUFDdkMsSUFBSSxLQUFLLEVBQUU7WUFDUCxHQUFHLEdBQU0sR0FBRyxTQUFJLE1BQU0sQ0FBQyxTQUFXLENBQUE7U0FDckM7UUFFRCxPQUFPLENBQ0g7WUFDSSxrQ0FDSSxJQUFJLEVBQUUsSUFBSSxFQUNWLFNBQVMsRUFBRSxHQUFHLEVBQ2QsRUFBRSxFQUFFLEVBQUUsRUFDTixLQUFLLEVBQUUsS0FBSyxFQUNaLFFBQVEsRUFBRSxVQUFDLEtBQUs7b0JBQ1osUUFBUSxDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO2dCQUNwQyxDQUFDLEVBQ0QsV0FBVyxFQUFFLFdBQVcsRUFDeEIsUUFBUSxFQUFFLFFBQVEsRUFDbEIsU0FBUyxFQUFFLFNBQVMsR0FDdEI7WUFDRCxTQUFTLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxJQUFJLENBQzNCLG9CQUFDLCtCQUFjLElBQUMsU0FBUyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsS0FBZSxHQUFJLENBQ25FO1lBQ0EsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUE3Q2EscUJBQVksR0FBRztRQUN6QixJQUFJLEVBQUUsQ0FBQztRQUNQLE1BQU0sRUFBRSxFQUFFO0tBQ2IsQ0FBQTtJQTJDTCxlQUFDO0NBQUEsQUEvQ0QsQ0FBOEIsaUJBQVMsR0ErQ3RDO0FBL0NZLDRCQUFRIn0=